import { Type } from '@angular/core';
import { NugetType } from '@models';
import {
    LibraryService,
    PackageService,
} from '@services';

export const NugetServiceFactory = (type: NugetType.Packages | NugetType.Libraries): Type<LibraryService | PackageService> => {
    switch (type) {
        case NugetType.Libraries: return LibraryService;
        case NugetType.Packages: return PackageService;
    }
};
